(() => {
  const words = [
    'silver earrings',
    'gemstone rings',
    'gymwear',
    'loungewear',
    'face creams & serums',
    'scented candles',
    'mobile accesories',
    'dainty jewellery',
    'laptrays',
    'pet care items',
  ];

  const timers = new WeakMap();
  const visibleInputs = new WeakSet();

  const stopTyping = (input) => {
    const timer = timers.get(input);
    if (timer) window.clearTimeout(timer);
    timers.delete(input);
  };

  const scheduleTyping = (input, callback, delay) => {
    stopTyping(input);
    timers.set(input, window.setTimeout(callback, delay));
  };

  const startTyping = (input) => {
    if (
      !input.isConnected ||
      document.hidden ||
      !visibleInputs.has(input) ||
      input.dataset.searchFocused === 'true' ||
      input.value.length > 0
    ) {
      stopTyping(input);
      return;
    }

    let wordIndex = Number(input.dataset.searchWordIndex || 0);
    let charIndex = Number(input.dataset.searchCharIndex || 0);
    let isDeleting = input.dataset.searchDeleting === 'true';

    const typeEffect = () => {
      if (
        !input.isConnected ||
        document.hidden ||
        !visibleInputs.has(input) ||
        input.dataset.searchFocused === 'true' ||
        input.value.length > 0
      ) {
        stopTyping(input);
        return;
      }

      const currentWord = words[wordIndex];
      input.placeholder = `I am shopping for ${currentWord.substring(0, charIndex)}`;

      let delay = isDeleting ? 120 : 220;
      if (!isDeleting && charIndex < currentWord.length) {
        charIndex += 1;
      } else if (isDeleting && charIndex > 0) {
        charIndex -= 1;
      } else {
        isDeleting = !isDeleting;
        delay = 1000;
        if (!isDeleting) wordIndex = (wordIndex + 1) % words.length;
      }

      input.dataset.searchWordIndex = String(wordIndex);
      input.dataset.searchCharIndex = String(charIndex);
      input.dataset.searchDeleting = String(isDeleting);
      scheduleTyping(input, typeEffect, delay);
    };

    typeEffect();
  };

  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const input = entry.target;

      if (entry.isIntersecting) {
        visibleInputs.add(input);
        startTyping(input);
      } else {
        visibleInputs.delete(input);
        stopTyping(input);
      }
    });
  }, { rootMargin: '80px' });

  const initialiseInput = (input) => {
    if (!(input instanceof HTMLInputElement) || input.dataset.animated === 'true') return;

    input.dataset.animated = 'true';
    input.dataset.searchFocused = 'false';
    input.value = '';

    const label = input.parentElement?.querySelector('.field__label');
    if (label) label.style.display = 'none';

    input.addEventListener('focus', () => {
      input.dataset.searchFocused = 'true';
      input.placeholder = 'Search...';
      stopTyping(input);
    });

    input.addEventListener('blur', () => {
      input.dataset.searchFocused = 'false';
      if (input.value.length === 0) startTyping(input);
    });

    visibilityObserver.observe(input);
  };

  const initialiseWithin = (root) => {
    if (root instanceof Element && root.matches('.search__input')) initialiseInput(root);
    root.querySelectorAll?.('.search__input').forEach(initialiseInput);
  };

  initialiseWithin(document);

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initialiseWithin(node);
      });
    });
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('.search__input[data-animated="true"]').forEach((input) => {
      if (document.hidden) stopTyping(input);
      else if (visibleInputs.has(input)) startTyping(input);
    });
  });
})();
